// ink-component
import React, { ChangeEvent } from 'react';

import Search, { SearchProps } from '../../../Search/Search';

export interface DropdownSearchProps extends SearchProps {
  /** onChange callback */
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  /** @ignore */
  render?: () => void;
  /** @ignore */
  className?: string;
}

/**
 * @purpose A search for Dropdown.Item(s)
 * @group Dropdown
 * @categories navigation
 */
const DropdownSearch = (props: DropdownSearchProps) => {
  const { onChange, render, className, ...otherProps } = props;
  return (
    <div className={className} tabIndex={-1}>
      <Search {...otherProps} onChange={onChange} />
    </div>
  );
};

DropdownSearch.defaultProps = {
  onChange: undefined,
};

DropdownSearch.displayName = 'Dropdown.Search';

export default DropdownSearch;
